/**
 * @generated SignedSource<<7fbb1dfea25c579158ef127e75c71d43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formatPdf"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHDS"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orientation"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "padding"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pages"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "renderingEngineVersion"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagIds"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variables"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "formatPdf",
        "variableName": "formatPdf"
      },
      {
        "kind": "Variable",
        "name": "isHDS",
        "variableName": "isHDS"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      },
      {
        "kind": "Variable",
        "name": "orientation",
        "variableName": "orientation"
      },
      {
        "kind": "Variable",
        "name": "padding",
        "variableName": "padding"
      },
      {
        "kind": "Variable",
        "name": "pages",
        "variableName": "pages"
      },
      {
        "kind": "Variable",
        "name": "renderingEngineVersion",
        "variableName": "renderingEngineVersion"
      },
      {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
      },
      {
        "kind": "Variable",
        "name": "tagIds",
        "variableName": "tagIds"
      },
      {
        "kind": "Variable",
        "name": "variables",
        "variableName": "variables"
      }
    ],
    "concreteType": "DocumentMutationResponse",
    "kind": "LinkedField",
    "name": "createDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documentId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDocumentMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateDocumentMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "2c5e8b5a088235e6d28e1659b509572e",
    "id": null,
    "metadata": {},
    "name": "CreateDocumentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDocumentMutation(\n  $name: String!\n  $pages: [DocumentSectionInput!]!\n  $scope: DocumentScopeEnum!\n  $offerId: ID\n  $variables: String\n  $padding: PaddingInput\n  $orientation: OrientationEnum!\n  $renderingEngineVersion: String\n  $formatPdf: formatPdfEnum\n  $isHDS: Boolean\n  $tagIds: [String]\n) {\n  createDocument(name: $name, pages: $pages, scope: $scope, offerId: $offerId, variables: $variables, padding: $padding, orientation: $orientation, renderingEngineVersion: $renderingEngineVersion, formatPdf: $formatPdf, isHDS: $isHDS, tagIds: $tagIds) {\n    ok\n    error\n    documentId\n  }\n}\n"
  }
};
})();

node.hash = "1f847b301d4742f119570c14441cf693";

export default node;
